import { Hashtracking } from "@otto-ec/global-hashtracking";
import { GlobalEvents } from "../../exports/event-q-bus";
import { o_global } from "../namespaces";

/*🤫*/
o_global.events<GlobalEvents>().on("assets.events.windowLoad", () => {
  if (window.o_util.toggle.get("ASSETS_GLOBAL_HASHTRACKING_ENABLED", true)) {
    new Hashtracking().hashTrack();
  }
});
